import cn from "clsx";
import { ActionMetrics } from "../components";
import EditStudyPlan from "../components/EditStudyPlan";
import { useLearningPlanTranslation } from "../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var AlertView = function AlertView(_ref) {
  var className = _ref.className,
    dataTestId = _ref['data-testid'],
    isDark = _ref.isDark,
    onEditStudyPlan = _ref.onEditStudyPlan,
    metrics = _ref.metrics;
  var _useLearningPlanTrans = useLearningPlanTranslation(),
    t = _useLearningPlanTrans.t;
  return /*#__PURE__*/_jsxs("div", {
    className: cn(
    // Grid
    'tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-2 md:tw-gap-4 tw-relative',
    // Pseudo: before, vertical line separator centered
    'before:tw-content before:tw-absolute before:tw-top-0 before:tw-left-[50%] before:tw-h-full before:tw-w-[1px] before:tw-bg-neutral-light-300 dark:before:tw-bg-neutral-dark-600',
    // Pseudo: before, hide vertical line separator on mobile
    'before:tw-hidden before:lg:tw-block', className),
    "data-testid": dataTestId,
    children: [/*#__PURE__*/_jsx(ActionMetrics, {
      title: t('LEARNING_PLAN_ACTIONS_TITLE'),
      isDark: isDark,
      metrics: metrics
    }), /*#__PURE__*/_jsx(EditStudyPlan, {
      isDark: isDark,
      onEditStudyPlan: onEditStudyPlan
    })]
  });
};
export default AlertView;